<template>
  <transition name="product-cart-popup--transition">
    <div v-if="open" class="product-cart-popup">
      <product-cart-checkout v-bind="{ checkoutUrl, checkoutText, emptyText, closeText, apiUrl }" />
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductCartCheckout from './product-cart-checkout.vue';

export default {
  name: 'product-cart-popup',
  components: {
    [ProductCartCheckout.name]: ProductCartCheckout,
  },
  props: {
    checkoutUrl: {
      type: String,
      required: true,
    },
    checkoutText: {
      type: String,
      required: true,
    },
    emptyText: {
      type: String,
      required: true,
    },
    closeText: {
      type: String,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('cart', ['open']),
  },
};
</script>

<style lang="scss">
@import './product-cart-popup';
</style>
